<template>
    <div v-if="showCookieComply | openModal">
        <aside class="cookie-comply" v-if="!openModal">
            <div class="cookie-comply__header">
                <h3 class="cookie-comply__header-title" v-html="$t('cookie_law_text')"/>
                  
                <p class="cookie-comply__header-description">

                    {{$t("cookie_law_privacy")}}
                    <a class="cookie-link" href="https://www.eduloc360.com/politica-de-cookies/" target="_blank"><b>{{$t('cookies_policy')}}</b></a>.
                </p>
            </div>
            <div class="cookie-comply__actions">
                <cookies-consent-button
                    :class-name="'cookie-comply__button-accept'"
                    @handleClick="handleAcceptAll"
                >
                    {{ acceptAllLabel }}
                </cookies-consent-button>
                <cookies-consent-button
                    :class-name="'cookie-comply__button-accept'"
                    @handleClick="handleRevokeAll"
                >
                    {{ revokeAllLabel }}
                </cookies-consent-button>
                <cookies-consent-button 
                    :class-name="'cookie-comply__button-accept'"
                    @handleClick="openPreferences"
                >
                    {{ preferencesLabel }}
                </cookies-consent-button>
            </div>
        </aside>
        <cookies-consent-modal
            :preferences="preferences"
            v-if="isModalOpen | openModal"
            @cookie-comply-close="closeModal"
            @cookie-comply-save="onSave"
            @selectAllChoices="$emit('selectAllChoices')"
            @revokeAllChoices="$emit('revokeAllChoices')"
        />
    </div>
</template>
<script>
import CookiesConsentModal from '@/components/CookiesConsentModal.vue';
import CookiesConsentButton from '@/components/CookiesConsentButton.vue';
export default {
    name: 'CookieComply',
    components: {
        CookiesConsentButton,
        CookiesConsentModal,
    },
    props: {
        headerTitle: {
            type: String,
            default: 'Cookie settings',
        },
        headerDescription: {
            type: String,
            default:
				'We use cookies and similar technologies to help personalize content and offer a better experience. You can opt to customize them by clicking the preferences button.',
        },
        preferencesLabel: {
            type: String,
            default: 'Preferences',
        },
        acceptAllLabel: {
            type: String,
            default: 'Accept All',
        },
        revokeAllLabel: {
            type: String,
            default: 'Deny All',
        },
        preferences: {
            type: Array,
            default: () => [],
        },
        target: {
            type: String,
            default: 'body',
        },
        openModal: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        showCookieComply: true,
        isModalOpen: false,
    }),
    mounted() {
        this.$cookies.isKey('cookies-accepted') && (this.showCookieComply = !1);
    },
    methods: {
        handleAcceptAll() {
            //(this.showCookieComply = !1),
            this.$cookies.set('cookies-accepted', 'all', 60 * 60 * 24 * 365, '/');
            this.$emit('on-accept-all-cookies');
            this.showCookieComply=false;
        },
        handleRevokeAll() {
            //(this.showCookieComply = !1),
            this.$cookies.set('cookies-accepted', 'basics', 60 * 60 * 24 * 365, '/');
            this.$emit('on-save-cookie-preferences', ["basics"]);
            this.showCookieComply=false;
        },
        openPreferences() {
            if(!this.isModalOpen || !this.openModal){
                this.isModalOpen = true;
            }
            //this.isModalOpen = !0;
        },
        onSave(e) {
            //(this.isModalOpen = !1), (this.showCookieComply = !1);
            // console.log(e)
            const o = Object.values(e);
            this.$cookies.set('cookies-accepted', JSON.stringify(o), 60 * 60 * 24 * 365, '/');
            this.$emit('on-save-cookie-preferences', o);
            this.showCookieComply=false;
            this.isModalOpen = false;
        },
        closeModal(){
            this.isModalOpen = false;
            this.$emit('close-cookies-modal');
        }
    },
};
</script>

<style lang="scss" scoped>
$spacing-sm: 8px;
$spacing-md: 14px;
$spacing-lg: 20px;
$color-green: #00c58e;
$color-white: #ffffff;
$box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.1), 0 1px 7px 1px rgba(0, 0, 0, 0.6);
$border-radius: 8px;
$background-overlay: rgba(34, 34, 34, 0.3);
$border-color-lightest: 1px solid rgba(200, 200, 200, 0.2);
$border-color-light: 1px solid rgba(0, 0, 0, 0.1);

.cookie-comply {
	display: grid;
	grid-gap: $spacing-lg;
	grid-template-columns: 1fr minmax(35%, 40%);
	position: absolute;
	bottom: $spacing-sm;
	left: $spacing-sm;
	right: $spacing-sm;
	background-color: $color-white;
	box-shadow: $box-shadow;
	padding: $spacing-md;
	border-radius: $border-radius;
}
@media (max-width: 1024px) {
	.cookie-comply {
		grid-template-columns: none;
	}
}

.cookie-comply__header {
	justify-self: flex-start;
	text-align: initial;
}
.cookie-comply__header-title,
.cookie-comply__header-description {
	margin: 0;
}
.cookie-comply__header-title {
	margin-bottom: $spacing-sm;
}
.cookie-comply__header-description {
	line-height: 20px;
}
.cookie-comply__actions {
	display: grid;
	grid-gap: $spacing-lg;
	grid-template-columns: repeat(2, 1fr);
	align-self: center;
}
.cookie-link{
    color: white;
}
.cookie-link:hover{
    color: var(--eduloc-red);
}
@media (max-width: 480px) {
	.cookie-comply__header {
		margin-bottom: $spacing-sm;
	}
	.cookie-comply__actions {
		grid-template-columns: auto;
	}
}
</style>